import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useEffect } from 'react';
import { SwipeRightIcon, RunningIcon, ChatIcon } from '../utils/icons';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '40px 20px',
    textAlign: 'center',
    background: 'var(--bg-primary)',
  },
  logo: {
    fontSize: '48px',
    fontWeight: '800',
    background: 'linear-gradient(135deg, var(--accent), #f7a)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    marginBottom: '16px',
  },
  tagline: {
    fontSize: '18px',
    color: 'var(--text-secondary)',
    marginBottom: '8px',
    maxWidth: '320px',
    lineHeight: 1.5,
  },
  subtitle: {
    fontSize: '14px',
    color: 'var(--text-muted)',
    marginBottom: '40px',
    maxWidth: '300px',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    maxWidth: '300px',
  },
  features: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginTop: '48px',
    maxWidth: '340px',
  },
  feature: {
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start',
    textAlign: 'left',
  },
  featureIcon: {
    fontSize: '20px',
    flexShrink: 0,
    width: '28px',
    textAlign: 'center',
  },
  featureText: {
    fontSize: '13px',
    color: 'var(--text-secondary)',
    lineHeight: 1.5,
  },
  featureTitle: {
    fontWeight: '600',
    color: 'var(--text-primary)',
    marginBottom: '2px',
    fontSize: '14px',
  },
};

export default function HomePage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/discover');
  }, [user, navigate]);

  return (
    <div style={styles.container}>
      <h1 style={styles.logo}>nova</h1>
      <p style={styles.tagline}>
        Date with confidence.
      </p>
      <p style={styles.subtitle}>
        Lifestyle & health transparency in dating.
      </p>

      <div style={styles.actions}>
        <button
          className="btn btn-primary btn-full"
          onClick={() => navigate('/register')}
          style={{ padding: '14px' }}
        >
          Create account
        </button>
        <button
          className="btn btn-secondary btn-full"
          onClick={() => navigate('/login')}
          style={{ padding: '14px' }}
        >
          Sign in
        </button>
      </div>

      <div style={styles.features}>
        <div style={styles.feature}>
          <SwipeRightIcon size={20} color="var(--accent)" />
          <div>
            <div style={styles.featureTitle}>Swipe to match</div>
            <div style={styles.featureText}>
              Like, pass, or super like profiles to find your match.
            </div>
          </div>
        </div>
        <div style={styles.feature}>
          <RunningIcon size={20} color="var(--accent)" />
          <div>
            <div style={styles.featureTitle}>Health transparency</div>
            <div style={styles.featureText}>
              Disclose vaccination status publicly, privately, or opt out entirely.
            </div>
          </div>
        </div>
        <div style={styles.feature}>
          <ChatIcon size={20} color="var(--accent)" />
          <div>
            <div style={styles.featureTitle}>Real-time chat</div>
            <div style={styles.featureText}>
              Message your matches instantly with typing indicators and read receipts.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
